/** Deep step definitions for platform-admin page tours. */

function c(targetId, title, body, extra = {}) {
  return {
    targetId,
    title,
    body,
    size: "compact",
    elementType: extra.elementType || "button",
    placement: extra.placement || "bottom",
    action: extra.action,
    ...extra,
  };
}

function d(targetId, title, body, action, outcome, extra = {}) {
  return {
    targetId,
    title,
    body,
    action,
    outcome,
    size: "standard",
    elementType: extra.elementType || "module",
    placement: extra.placement || "bottom",
    tip: extra.tip,
    warning: extra.warning,
    ...extra,
  };
}

export const ADMIN_PAGE_TOURS_DEEP = [
  {
    id: "admin-home",
    title: "Platform Dashboard",
    route: "/admin",
    description: "Tenants, users, licenses, and system health",
    steps: [
      d("tour-admin-dashboard", "Platform statistics", "Total tenants, users, licenses, and uptime.", "Review daily for growth and health.", "Platform-wide visibility.", { elementType: "stat" }),
      d("tour-admin-quick-actions", "Quick actions", "Add Tenant, Tenants, Licenses, Settings shortcuts.", "Click Add Tenant to onboard.", "Fast administration.", { elementType: "button", placement: "top" }),
      d("tour-admin-tenant-table", "Recent tenants", "Latest orgs with status and license info.", "Click rows to manage tenants.", "Quick tenant access.", { elementType: "table", placement: "top" }),
    ],
  },
  {
    id: "admin-tenants",
    title: "Tenant Management",
    route: "/admin/tenants",
    description: "Create and manage customer organisations",
    steps: [
      d("tour-tenants-header", "Tenants header", "Manage all customer orgs, licenses, and modules.", "Use search to find by organisation name.", "Efficient lookup.", { elementType: "module" }),
      c("tour-add-tenant", "Create Tenant Admin", "Provisions org: name, admin, license, modules.", { elementType: "button", placement: "left", action: "Tenant DB is created automatically.", tip: "Enable Consent, DSAR, DSPM per contract." }),
      d("tour-tenants-stats", "Tenant statistics", "Total, active, and suspended organisations.", "Monitor before billing reviews.", "Accurate portfolio view.", { elementType: "stat" }),
      d("tour-tenants-table", "Tenants table", "Edit limits, toggle modules, suspend, deactivate.", "Click Edit on a row to update.", "Full tenant lifecycle control.", { elementType: "table", placement: "top" }),
    ],
  },
  {
    id: "admin-licenses",
    title: "License Management",
    route: "/admin/licenses",
    description: "Slot usage across all tenants",
    steps: [
      d("tour-licenses-page", "License summary", "Allocated, used slots, and tenants near limit.", "Watch Near Limit for upsell.", "Proactive capacity planning.", { elementType: "stat" }),
      d("tour-licenses-list", "Per-tenant usage", "Used vs limit with progress bars.", "Identify tenants above 80%.", "No surprise license blocks.", { elementType: "card", placement: "top" }),
    ],
  },
  {
    id: "admin-settings",
    title: "Platform Settings",
    route: "/admin/settings",
    description: "SMTP, templates, and email logs",
    steps: [
      d("tour-admin-settings-profile", "Super admin profile", "Platform administrator account details.", "Verify name and email.", "Account identity confirmed.", { elementType: "card" }),
      d("tour-smtp-settings", "Platform SMTP", "Default mail server for onboarding and notifications.", "Enable SMTP, save, send test email.", "Email delivery for all tenants.", { elementType: "panel", placement: "right" }),
      d("tour-admin-email-cards", "Templates & logs", "Email branding and delivery logs.", "Open Templates and Logs cards.", "Professional communications.", { elementType: "card", placement: "top" }),
    ],
  },
];
